import { render, staticRenderFns } from "./SoldApplianceList.vue?vue&type=template&id=9ad89478&scoped=true"
import script from "./SoldApplianceList.vue?vue&type=script&lang=js"
export * from "./SoldApplianceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad89478",
  null
  
)

export default component.exports